import { FactoryFormsModule } from '@b2b/common/factories/forms/forms.factory';
import { applyResponseDataToFormDefinition } from './utils';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';

export const OrdersDetailFormsEditControllerModule = angular
  .module('acme.view.application.orders.detail.forms.edit.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.validate',
    'acme.common.factory.notice',
    FactoryFormsModule,
    'acme.common.service.calendar',
    'acme.common.service.helpers',
  ])
  .controller('OrdersDetailFormsEditController', [
    '$scope',
    '$state',
    '$timeout',
    '$uibModal',
    '$filter',
    'ApiService',
    'ValidateService',
    'NoticeFactory',
    'OrderFormResponseData',
    'CalendarService',
    'HelpersService',
    'FormsFactory',
    function OrdersDetailFormsEditController(
      $scope: IScope & { ordersDetailFormsEdit: TODO },
      $state: StateService,
      $timeout: ITimeoutService,
      $uibModal: UIBModalService,
      $filter: IFilterService,
      ApiService: ApiService,
      ValidateService: TODO,
      NoticeFactory: NoticeFactory,
      OrderFormResponseData: TODO,
      CalendarService: TODO,
      HelpersService: TODO,
      FormsFactory: TODO
    ) {
      $scope.ordersDetailFormsEdit = {
        model: {},
        notice: {},
        eventName: '',
        eventDate: '',
        eventStartTime: '',

        init: function () {
          const formsFactory = new FormsFactory();

          formsFactory.init();

          $scope.$emit('Application::contentTitleChange', {
            title: 'Edit Form Response',
            buttonLeft: {
              label: 'Cancel',
              permissions: ['ORDER_VIEW'],
              action: function () {
                window.history.go(-1);
              },
            },
            buttonRight: {
              label: 'Save',
              permissions: ['FORM_RESPONSE_UPDATE'],
              action: function () {
                const self = $scope.ordersDetailFormsEdit;
                if (self.requiredFormFields()) {
                  self.handleFormErrorNotice('Fill in all required fields');
                } else {
                  self.save();
                }
              },
            },
          });
          if (OrderFormResponseData.data && OrderFormResponseData.data.success) {
            const dataPayload = OrderFormResponseData.data.payload;
            this.eventName = dataPayload.itemName || '';
            if (dataPayload.eventStartTime) {
              this.eventDate = $filter('date')(
                CalendarService.parseDate(dataPayload.eventStartTime),
                HelpersService.dateFormats.standardDate
              );
              this.eventStartTime = $filter('date')(
                CalendarService.parseDate(dataPayload.eventStartTime),
                HelpersService.dateFormats.standardTime
              );
            }
          }
          this.getFormResponse();
          this.notice = new NoticeFactory();
        },

        requiredFormFields: function () {
          const inputs = $('form#orders-detail-forms-container').find('input');

          for (let i = 0, ii = inputs.length; i < ii; i++) {
            if ($(inputs[i]).prop('required') === true && !$(inputs[i]).val()) {
              return true;
            }
          }

          return false;
        },

        handleFormErrorNotice: function (msg) {
          $scope.ordersDetailFormsEdit.notice.showErrorMessages([{ message: msg }]);
        },

        save: function () {
          const self = $scope.ordersDetailFormsEdit;
          this.responseComplete();
        },

        getFormResponse: function (data) {
          ApiService.form.responses
            .detail({ id: $state.params.responseId })
            .then(this.success.init)
            .catch(this.error.init);
        },

        updateFormResponse: function (data) {
          ApiService.form.responses.update(data).then(this.success.update).catch(this.error.update);
        },

        /**
         * Renders form given a form definition object
         */
        renderForm: function (formDefinition: TODO) {
          let fieldName;
          const responseData = this.model.responseData;

          try {
            formDefinition.sourceFormDefinition = $scope.ordersDetailFormsEdit.updateForm();
            ($('#orders-detail-forms-markup') as TODO).formRender({
              formData: formDefinition.sourceFormDefinition,
              dataType: 'json',
            });

            $timeout(function () {
              for (let i = 0, ii = responseData.fields.length; i < ii; i++) {
                /*
                Check for response data has
                otherValue even if its value is empty show the text box and select the button
              */

                if (responseData.fields[i].hasOwnProperty('otherValue')) {
                  fieldName = responseData.fields[i].name.replace('[]', '');
                  // Found other value
                  $('#' + fieldName + '-other').click();
                  $('#' + fieldName + '-other-value')
                    .val(responseData.fields[i].otherValue)
                    .show();
                }
              }
            }, 100);
          } catch (e) {
            console.error('OrdersDetailFormsEditController::renderForm', e);
          }
        },

        // TODO: Implement
        findField: function (fields, name) {
          for (let i = 0, ii = fields.length; i < ii; i++) {
            if (fields[i].name === name) {
              return {
                field: fields[i],
                index: i,
              };
            }
          }

          return false;
        },

        updateForm: function () {
          const self = $scope.ordersDetailFormsEdit;
          let formDefinition: TODO[] = [];
          const responseData = self.model.responseData;

          try {
            formDefinition = $.parseJSON(self.model.publishedFormTemplate.sourceFormDefinition);
          } catch (e) {
            console.error('Failed to parse form definition', e);
            return;
          }

          return angular.toJson(applyResponseDataToFormDefinition(responseData, formDefinition));
        },

        /**
         * Checks if input contatins radio-group string
         */
        isRadioGroup: function (name: string) {
          return !!name.match(/^radio-group-[0-9]/g);
        },

        /**
         * Checks if input contatins radio-group string
         */
        isRadioOrCheckboxInput: function (name: string) {
          return !!name.match(/^radio-[0-9]/g) || !!name.match(/^checkbox-[0-9]/g);
        },

        /**
         * Callback for form submission
         * This should call next once the responses are complete
         */
        responseComplete: function () {
          // Capture response in FormsService
          const data = $('#orders-detail-forms-container').serializeArray();
          /**
           * Unchecked checkboxes are not automatically serialized
           * so we need to do this manually
           */
          $('#orders-detail-forms-markup input:checkbox').map(function (i, o) {
            const el = $(o);
            // Update only false values
            // True values are added normally
            if (!(this as TODO).checked) {
              data.push({ name: (this as TODO).name, value: '' });
            }
          });

          if (!$scope.$$phase) {
            $scope.$apply();
          }

          const response = this.processResponse(data);
          console.log('OrdersFormsController::responseComplete', response);

          // Save response
          this.model.responseData = response.responseData;
          this.model.customFields = response.customFields;
          this.updateFormResponse(this.model);
        },

        /**
         * Format for formResponse
         */
        processResponse: function (data): {
          responseData: { fields: TODO };
          customFields: TODO[];
        } {
          const customFields: TODO[] = [];
          let field;
          let label;

          data = this.processGroupField(data);

          for (let i = 0, ii = data.length; i < ii; i++) {
            let fieldName = data[i].name;
            if (this.isGroupField(fieldName)) {
              //this is a group element
              fieldName = fieldName.replace('[]', '');
              field = $('#' + fieldName + ', #' + fieldName + '-0');
            } else if (this.isRadioGroupField(fieldName)) {
              field = $('input[type="radio"][name="' + fieldName + '"]:checked');
            } else {
              field = $('#' + fieldName);
            }

            label = this.processLabelValue(fieldName);
            const customField = field.attr('data-custom-field');

            if (customField && customField != 'none') {
              const customFieldData = customField.split('%%');
              // Parse custom field value which is {{ name }}-{{ id }}

              customFields.push({
                name: customFieldData[1],
                value: data[i].value,
              });
              data[i].customFieldLabel = customFieldData[2];
              data[i].customFieldName = customFieldData[1];
              data[i].customFieldId = customFieldData[0];
            }

            data[i].label = label;
          }

          return {
            responseData: {
              fields: data,
            },
            customFields: customFields,
          };
        },

        /**
         * Checks if field is of type radio group
         */
        isRadioGroupField: function (field: string) {
          return field.indexOf('radio-group-') === 0;
        },

        /**
         * Checks if field is of type multiselect group []
         */
        isGroupField: function (field: string) {
          return !!field && field.indexOf('[]') > -1;
        },

        /**
         * Formats formResponse  data
         * Joins any number of related group fields
         */
        processGroupField: function (data) {
          const r: TODO[] = [];
          const collection = {};

          for (let i = 0, ii = data.length; i < ii; i++) {
            let field = data[i].name;
            if (this.isGroupField(field)) {
              field = field.replace('[]', '');
              if (!collection[field]) {
                collection[field] = angular.copy(data[i]);
              } else {
                //append values
                if (data[i] && data[i].value.length) {
                  /*
                   *  If the other checkbox is checked then only
                   *  add it's value to the collection
                   * */
                  if ($('#' + field + '-other-value').val() && data[i].value == $('#' + field + '-other-value').val()) {
                    if ($("input:checkbox[name='" + field + "[]']:last").is(':checked')) {
                      collection[field].value = collection[field].value + ', ' + data[i].value;
                    }
                  } else {
                    collection[field].value = collection[field].value + ', ' + data[i].value;
                  }
                }

                // Have to handle 'other' type values correctly
                // Since should only ever occur at the end of a list
                // We can get away with doing this type of string matching
                /**
                 * Regexp checks to see if a string like "on, any value"
                 * exists at the end of collection[field].value
                 */
                if (collection[field].value.match(/.*?\s*on\,\s.*?$/g)) {
                  /**
                   * Same as above except that this time we are capturing
                   * and removing the "on, value" value from the string values
                   * We replace this with "Other: value"
                   */
                  collection[field].value = collection[field].value.replace(/(.*?)\s*on\,\s(.*?$)/g, '$1 Other: $2');
                  collection[field].otherValue = data[i].value;
                }
              }
            } else {
              const inputValue = angular.copy(data[i]);
              if (!collection[field]) {
                collection[field] = inputValue;
              } else if (collection[field].value === 'on') {
                collection[field].value = 'Other: ' + inputValue.value;
                collection[field].otherValue = data[i].value;
              }

              if (/^checkbox/.test(field) && !$('#' + field).attr('toggle') && collection[field].value === 'on') {
                collection[field].value = 'checked';
              }
            }
          }

          for (const key in collection) {
            if (collection.hasOwnProperty(key)) {
              const fieldObject = {
                value: collection[key].value,
                label: collection[key].label,
                name: collection[key].name,
                customFieldId: collection[key].customFieldId,
                customFieldLabel: collection[key].customFieldLabel,
                customFieldName: collection[key].customFieldName,
              } as {
                value: TODO;
                label: TODO;
                name: TODO;
                customFieldId: TODO;
                customFieldLabel: TODO;
                customFieldName: TODO;
                otherValue?: TODO;
              };

              /*
               * Setting the otherValue prop even if its value is null or empty
               * This check is needed because only the other field in the collection can
               * have this property.
               */
              if (collection[key].hasOwnProperty('otherValue')) {
                fieldObject.otherValue = collection[key].otherValue;
              }
              r.push(fieldObject);
            }
          }

          return r;
        },

        /**
         * Format for fieldName, processing label
         * and obtaining the clean value
         */
        processLabelValue: function (fieldName: string) {
          return $.trim(
            $('label[for="' + fieldName + '"]')
              .children()
              .remove()
              .end()
              .text()
          );
        },

        success: {
          init: function (response) {
            const self = $scope.ordersDetailFormsEdit;
            self.model = response.data.payload;
            self.renderForm(self.model.publishedFormTemplate);
          },
          update: function (response) {
            $scope.ordersDetailFormsEdit.notice.hideErrorMessages();

            $scope.ordersDetailFormsEdit.notice.showSuccessMessages([{ message: 'Successfully Saved!' }]);

            $timeout(function () {
              $scope.ordersDetailFormsEdit.notice.hideSuccessMessages();
              // going back to the previous state after save.
              window.history.go(-1);
            }, 3000);
          },
        },

        error: {
          init: function (response) {},
          update: function (response) {
            $scope.ordersDetailFormsEdit.notice.showErrorMessages([{ message: response.data.error }]);
          },
        },
      };

      $scope.ordersDetailFormsEdit.init();
    },
  ]).name;
